import './App.css';
import * as d3 from 'd3'
import {useWorldAtlas} from './useWorldAtlas'
import {Location} from './Location'
import {DateRange} from './DateRange'
import {useRef, useEffect, useState} from 'react'
import * as topojson from 'topojson'

  const projection = d3.geoEqualEarth()
const path = d3.geoPath(projection)
const graticule = d3.geoGraticule().step([10, 10])


  const coordLookup = {
  world: [0,0],
  northAmerica: [100,0],
  southAmerica: [56,0],
  europe: [-4,0],
  asia: [-87,0],
  africa: [-26, 0],
  australia: [-133,0],
  pacificRim: [150,0]
}


function App() {



  const [mapFocus, setMapFocus] = useState('world');
  const [timespan, setTimespan] = useState('month')
  const [quakesData, setQuakesData] = useState(null)

  projection.rotate(coordLookup[mapFocus])

  const atlasData = useWorldAtlas();
  const circle = useRef();
  const tooltip = useRef();

   useEffect(() => {
  d3.json(`https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_${timespan}.geojson`).then(data => setQuakesData(data.features.map(d => {
 return {mag: d.properties.mag, place: d.properties.place, time: d.properties.time, coords: d.geometry.coordinates.slice(0,2)}
})))
 },[timespan])


    const handleHover = (e) => {
    
    tooltip.current.style.left = e.clientX + 20 + 'px'
    tooltip.current.style.display = "inline-block"
    tooltip.current.innerHTML = `<span style="font-size: 1.1rem; font-weight: bold">${e.target.dataset.mag}</span><br>${e.target.dataset.place}<br>${d3.timeFormat('%m/%d/%Y')(new Date(+e.target.dataset.date))}`
    if(e.clientY < 420){
      tooltip.current.style.top = e.clientY + 'px'
    }
    else{
      tooltip.current.style.top = e.clientY - 50 + 'px'
    }

  }

   const handleLeave = (e) => {
    tooltip.current.style.display = "none"
    tooltip.current.innerHTML = ''
  }


  if(!atlasData || !quakesData){
    return <h1>Loading...</h1>
  }

    const countries = topojson.feature(atlasData, atlasData.objects.countries).features

    const magnitude = [4,5,6,7,8,9]
    const colorMag = ['red', 'yellow', 'green', 'blue', 'orange', 'magenta']

  const colorScale = d3.scaleOrdinal()
  .domain(magnitude)
  .range(colorMag)

  return <>

  <h1 style={{margin: '10px', textAlign: 'center'}}>Earthquake Data from USGS</h1>
  <div style={{display: 'block'}} className="form-components">
  <Location mapFocus={mapFocus} setMapFocus={setMapFocus} />
  <DateRange timespan={timespan} setTimespan={setTimespan} />
</div>

  <svg height={500} width={1000} transform={'translate(150, 0)'}>



    <path fill={'#d8d9e6'} d={path({type: 'Sphere'})} />

  

    {countries.map((d) => {
      return <path d={path(d)} stroke={'white'} fill={'#4e9694'} />
    })}

      {quakesData.map((d) => {

      const [long, lat] = projection(d.coords)

      return <circle onMouseEnter={handleHover} onMouseLeave={handleLeave} ref={circle} fill={colorScale(Math.floor(d.mag))} cx={long} cy={lat} r={8} data-mag={d.mag} data-place={d.place} data-date={d.time}></circle>
    })}

    <g transform={'translate(10, 15)'}>
      <text x={-5}>Magnitude</text>
      {colorMag.map((d, i) => {
        return <>
        <circle r={6} fill={d} cx={0} cy={i * 15 + 15}></circle>
        <text x={10} y={i * 15 + 20}>{'> ' + magnitude[i]}</text>
        </>
      })}
    </g>
  </svg>

<div id="tooltip" ref={tooltip} style={{
  position: 'absolute',
  display: 'none',
  background: 'white',
  zIndex: 10000,
  borderRadius: '5px',
  border: '2px solid steelblue',
  padding: '10px'
  }}></div>
  </>
}
export default App;
